<template>
  <div>
    <div class="alert alert-danger" v-if="errorMsg">{{ errorMsg }}</div>

    <div class="row mb-2">
      <div class="col-auto">
        <button class="btn btn-primary gdq_faded gdq-font-size-80" @click="addNew">
          <span class="icon-plus mr-1"></span>Add trainer
        </button>
      </div>
    </div>

    <div class="card mb-3" v-if="showForm">
      <div class="card-body">
        <h6 class="card-title">{{ editing.id > 0 ? 'Edit trainer' : 'New trainer' }}</h6>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">First name</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.first_name" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Last name</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.last_name" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Role</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.role" /></div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">E-mail</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.email" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Phone</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.phone" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Photo URL</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.photo_url" /></div>
            </div>
            <div class="mb-3">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="lhctac" v-model="editing.show_sue_cta" />
                <label class="form-check-label" for="lhctac">Show in Sue answer ("contact me")</label>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label class="col-form-label d-block mb-2">Bio</label>
          <VueEditor v-model="editing.bio" />
        </div>
        <div>
          <button class="btn btn-outline-secondary" @click="cancel">Cancel</button>
          <button class="btn btn-primary float-end" :disabled="saving" @click="save">
            <fa-icon name="check" />Save
          </button>
        </div>
      </div>
    </div>

    <table class="table table-hover lh-table">
      <thead>
        <tr>
          <th style="width: 40px;">#</th>
          <th>Name</th>
          <th>Role</th>
          <th>E-mail</th>
          <th>Sue CTA</th>
          <th style="width: 110px;">⚡</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in rows" :key="item.id" style="cursor: pointer;" @click="editRow(item)">
          <td>{{ item.sort }}</td>
          <td>{{ item.first_name }} {{ item.last_name }}</td>
          <td>{{ item.role || '-' }}</td>
          <td>{{ item.email || '-' }}</td>
          <td>{{ item.show_sue_cta ? 'Yes' : 'No' }}</td>
          <td>
            <span class="me-2" style="cursor: pointer;" title="Move up" v-if="i > 0" @click.prevent.stop="move(item, i, -1)">
              <fa-icon name="arrow-up" />
            </span>
            <span class="me-2" style="cursor: pointer;" title="Move down" v-if="i < rows.length - 1" @click.prevent.stop="move(item, i, 1)">
              <fa-icon name="arrow-down" />
            </span>
            <span style="cursor: pointer;" title="Delete" @click.prevent.stop="delRow(item)">
              <fa-icon name="trash-alt" />
            </span>
          </td>
        </tr>
        <tr v-if="rows.length === 0">
          <td colspan="6" class="text-center text-muted py-3">No trainers</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import VueEditor from '../CustomControls/VueEditor.vue'

export default {
  name: 'LHCourseTrainers',
  components: { VueEditor },
  props: {
    courseId: { type: Number, required: true },
    rows: { type: Array, required: true }
  },
  data () {
    return {
      showForm: false,
      saving: false,
      errorMsg: '',
      editing: this.emptyRow()
    }
  },
  methods: {
    emptyRow () {
      return {
        id: 0, sort: 0, first_name: '', last_name: '', role: '',
        bio: '', email: '', phone: '', photo_url: '', show_sue_cta: false
      }
    },
    addNew () {
      this.errorMsg = ''
      this.editing = this.emptyRow()
      this.editing.sort = this.rows.length + 1
      this.showForm = true
    },
    editRow (r) {
      this.errorMsg = ''
      this.editing = { ...r, show_sue_cta: !!r.show_sue_cta }
      this.showForm = true
    },
    cancel () {
      this.showForm = false
    },
    async save () {
      this.saving = true
      this.errorMsg = ''
      try {
        const body = {
          sort: this.editing.sort,
          first_name: this.editing.first_name,
          last_name: this.editing.last_name,
          role: this.editing.role,
          bio: this.editing.bio,
          email: this.editing.email,
          phone: this.editing.phone,
          photo_url: this.editing.photo_url,
          show_sue_cta: this.editing.show_sue_cta ? 1 : 0
        }
        if (this.editing.id > 0) {
          await this.$store.dispatch('learninghub_trainer_update', { id: this.editing.id, body })
        } else {
          body.course_id = this.courseId
          await this.$store.dispatch('learninghub_trainer_save', { body })
        }
        this.showForm = false
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result : (e.message || 'Save failed')
      }
      this.saving = false
    },
    async delRow (r) {
      if (!confirm('Delete trainer "' + r.first_name + ' ' + r.last_name + '"?')) return
      try {
        await this.$store.dispatch('learninghub_trainer_delete', { id: r.id })
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result : (e.message || 'Delete failed')
      }
    },
    async move (item, i, dir) {
      const ids = this.rows.map(x => x.id)
      const j = i + dir
      ;[ids[i], ids[j]] = [ids[j], ids[i]]
      try {
        await this.$store.dispatch('learninghub_reorder', { body: { entity: 'trainer', ids } })
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.message || 'Reorder failed'
      }
    }
  }
}
</script>

<style>
.lh-table {
  font-size: 0.9rem !important;
}
</style>
